import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Configuracion } from '../../contants/configuracion.constant';

@Component({
  selector: 'app-external-sp',
  templateUrl: './external-sp.component.html',
  styleUrls: ['./external-sp.component.scss']
})
export class ExternalSPComponent {
  listaSP: string[] = [];
  constructor(private sanitizer:DomSanitizer) {
  }

  ngOnInit() {
    Configuracion.SP_EXTERNOS.forEach(function(sp){
      this.listaSP.push(this.sanitizer.bypassSecurityTrustResourceUrl(sp));
    }, this)    
  }
}



// WEBPACK FOOTER //
// ./src/app/components/external-sp/external-sp.component.ts